<template>
  <div style="position:relative">
    <div style="display: flex; justify-content: space-between; align-items: center">
      <h2>{{ onlyArchived ? 'Archivierte ' : '' }} Dealliste</h2>
      <RouterLink :to="onlyArchived ? '/deallist' : '/deallist/archived'"
                  style="color:#607D8B;">
        {{ onlyArchived ? 'zur Dealliste' : 'zu den archiverten Deals' }}
      </RouterLink>
    </div>
    <transition name="fade" mode="out-in">
      <div class="actionButtons">
        <AdaButton title="Excel" @click="generateExcel" :loading="excelLoading" type="excel"
                   style="margin: 1rem 1rem 2rem 0;" icon="icon-spreadsheet"
                   v-tooltip="'Excel Export generieren'"
        ></AdaButton>
        <AdaButton title="Mail" @click="getFilteredEntries" :loading="mailLoading" type="mail"
                   style="margin: 1rem 1rem 2rem 0" icon="icon-mail"
                   v-tooltip="'Tabelle für E-Mail generieren'"
        ></AdaButton>
        <AdaButton title="" @click="openColumnSettings" type="blue"
                   class="col_settings" v-tooltip="'Spalten verwalten'"
                   style="margin: 1rem 1rem 2rem 0" icon="cog" :unicon="true"
                   :custom-styles="{textAlign: 'center'}"></AdaButton>
      </div>
    </transition>
    <AdaTable :class="{'archive': onlyArchived}" :data="onlyArchived ? 'getArchivedDeallist' : 'getDeallist'"
              :columns="columns" :selectableRows="true" @rowClicked="showDetails"
              :key="updateKey" :deallist="true" @selected="updateSelectedRows"
              @applyFilter="updateKey++" v-bind="$attrs" :onlyArchived="onlyArchived"
              @allChecked="setCbxAll" :showActionCol="showActionCol"
              :table-length="50" :saveSearch="true" :transformers="transformers"
              @action:delete="openDeleteConfirm"
    ></AdaTable>

    <!--  D E T A I L S   D I A L O G  -->
    <Dialog :show="showDetailsDialog" @close="showDetailsDialog = false" :show-close-button="true"
            @keyup.esc="showDetailsDialog = false" id="headlineDialog" class="detailDialog">
      <div class="content" v-if="selected && !dropdownsLoading" style="width:100%;">
        <h3 style="margin-top:0; word-break: break-all; padding-right:20px">Deal bearbeiten</h3>
        <div class="contentWrapper">
          <div class="row">
            <Input label="Dealname" v-model="selected.deal_name"></Input>
          </div>
          <div class="row">
            <Input label="Deal ID" v-model="selected.deal_id"></Input>
            <Dropdown label="Advertiser"
                      :items="getDropdown('advertisers', 'advertiser', 'advertiser_name')"
                      :initial="selectedOriginal.advertiser" item-name="advertiser_name" :editable="false"
                      :select-on-click="true"
                      @enter="updateModel($event, 'advertiser', 'advertiser_name')"
                      :noReInit="true"></Dropdown>
          </div>
          <div class="row">
            <Dropdown label="Deal Type" :items="getDropdown('dealtypes', 'deal_type', 'display_name')"
                      :initial="selectedOriginal.deal_type" :editable="false" :select-on-click="true"
                      item-name="display_name"
                      @enter="updateModel($event, 'deal_type', 'display_name')" :noReInit="true"></Dropdown>
            <Dropdown label="Placement" :items="getDropdown('placements', 'placement', 'name')"
                      :initial="selectedOriginal.placement" :editable="false" :select-on-click="true"
                      @enter="updateModel($event, 'placement', 'name')" :noReInit="true"></Dropdown>
            <Dropdown label="Device" :items="getDropdown('devices', 'device', 'display_name')"
                      :initial="selectedOriginal.device" item-name="display_name" :editable="false"
                      :select-on-click="true"
                      @enter="updateModel($event, 'device', 'display_name')" :noReInit="true"></Dropdown>
          </div>
          <div class="row">
            <Dropdown label="Format" :items="getDropdown('formats', 'format', 'name')"
                      :initial="selectedOriginal.format" :editable="false" :select-on-click="true"
                      @enter="updateModel($event, 'format', 'name')" :noReInit="true"
            ></Dropdown>
            <Input label="CPM" v-model="selected.cpm"></Input>
            <Input label="Targeting" v-model="selected.targeting"></Input>
          </div>
          <div class="row">
            <div style="position: relative; width:100%;">
              <Input label="Start" v-model="selected.start" disabled
                     style="width:85% !important;"></Input>
              <DatePicker :set-max="false" class="datePicker combo-item"
                          @close="updateDate($event, 'start')"
                          :isRange="false" title="Startdatum auswählen"
                          style="position:absolute; top:7px; right:20px; "></DatePicker>
            </div>
            <div
                style="position: relative;width: 100%;display: flex;align-items: center;justify-content: space-between;">
              <Input :label="selected.end ? 'End' : 'End (Always on)'" v-model="selected.end" disabled
                     style="width:85% !important;"></Input>
              <DatePicker :set-max="false" class="datePicker combo-item"
                          @close="updateDate($event, 'end')"
                          :isRange="false" title="Enddatum auswählen" :nullable="true"
                          style="position:absolute; top:7px; right:20px; "></DatePicker>
            </div>
          </div>
          <div class="row">
            <Dropdown label="Seat" :items="getDropdown('seats', 'seat', 'name')"
                      :initial="selectedOriginal.seat" :editable="false" :select-on-click="true"
                      @enter="updateModel($event, 'seat', 'name')" :noReInit="true"></Dropdown>
            <Input label="Seat ID" v-model="selected.seat_id"></Input>
          </div>
          <div class="row">
            <Dropdown label="DSP"
                      :items="$store.getters['deallist/distinctDSPs']"
                      :select-on-click="true"
                      :editable="true" :noReInit="true"
                      :initial="selected.dsp"
                      @enter="selected.dsp = typeof $event.edited !== 'undefined' ? $event.edited : $event.name"></Dropdown>

            <Dropdown label="SSP"
                      :items="[{name:'Google'}, {name:'Yieldlab'}, {name:'Xandr'}, {name:'SmartX'}]"
                      :select-on-click="true"
                      :editable="true" :noReInit="true"
                      :initial="selected.ssp"
                      @enter="selected.ssp = $event.name"></Dropdown>
          </div>
          <div class="row">
            <Input label="Agenturgruppe" v-model="selected.agency_group"></Input>
            <Input label="Agentur" v-model="selected.agency"></Input>
          </div>
          <div class="row">
            <Input label="Budget" v-model="selected.budget"></Input>
            <Dropdown label="Transparenz" :items="getDropdown('brandings', 'branding', 'name')"
                      :initial="selectedOriginal.branding" :editable="false" :select-on-click="true"
                      @enter="updateModel($event, 'branding', 'name')" :noReInit="true"></Dropdown>
          </div>
          <div class="row">
            <Dropdown label="Kennung International"
                      :items="getDropdown('salesoffices', 'salesoffice', 'name')"
                      :initial="selectedOriginal.salesoffice" :editable="false" :select-on-click="true"
                      @enter="updateModel($event, 'salesoffice', 'name')" :noReInit="true"></Dropdown>
            <Dropdown label="Reporting" :items="getDropdown('reportings', 'reporting', 'name')"
                      :initial="selectedOriginal.reporting" :editable="false" :select-on-click="true"
                      @enter="updateModel($event, 'reporting', 'name')" :noReInit="true"></Dropdown>
          </div>
          <div class="row">
            <Input label="Opp. ID" v-model="selected.opp_id"></Input>
          </div>
          <div class="row">
            <Dropdown label="Ansprechpartner" :items="getDropdown('users', 'contact', 'full_name')"
                      :initial="selectedOriginal.contact" item-name="full_name" :editable="false"
                      :select-on-click="true"
                      @enter="updateModel($event, 'contact', 'full_name')" :noReInit="true"></Dropdown>
            <Dropdown label="Trafficker" :items="getDropdown('users', 'trafficker', 'full_name')"
                      :initial="selectedOriginal.trafficker" item-name="full_name" :editable="false"
                      :select-on-click="true"
                      @enter="updateModel($event, 'trafficker', 'full_name')" :noReInit="true"></Dropdown>
          </div>
          <div class="row">
            <div class="textarea floating border">
                        <textarea class="floating__input" v-model="selected.comment" placeholder="placeholder"
                                  rows="3"/>
              <label class="floating__label" data-content="Freifeld"></label>
            </div>
          </div>
          <div class="row">
            <div class="textarea floating border">
                        <textarea class="floating__input" v-model="selected.notes" placeholder="Bemerkungen"
                                  rows="3"/>
              <label class="floating__label" data-content="Bemerkungen"></label>
            </div>
          </div>
          <div v-if="selectedOriginal && selected">
            <label>Archivieren ? </label>
            <RadioButton id="archived_yes" title="Ja" :value="selected.is_archived === 1" :rounded="true"
                         @change="selected.is_archived = 1"></RadioButton>
            <RadioButton id="archived_no" title="Nein" :value="selected.is_archived === 0" :rounded="true"
                         @change="selected.is_archived = 0"></RadioButton>
          </div>
        </div>
        <div class="button_container">
          <AdaButton type="grey" title="Abbrechen" @click="showDetailsDialog = false; selected = null"
                     style="margin: 1rem 1rem 2rem 0"></AdaButton>
          <AdaButton title="Speichern" @click="save" :loading="loading"
                     style="margin: 1rem 1rem 2rem 0"></AdaButton>
        </div>
      </div>
      <div v-else style="height:50vh; width:100%; display:flex; align-items: center; justify-content: center">
        <DotLoader class="loader"></DotLoader>
      </div>
    </Dialog>

    <!--  M A I L   T A B L E   D I A L O G  -->
    <Dialog :show="showMailDialog" @close="showMailDialog = false" :show-close-button="true"
            @keyup.esc="showMailDialog = false" class="mailDialog">
      <div style="overflow: auto">
        <div style="display: flex;align-items: center">
          <h3 style="margin-top:0;">Mail Template </h3>
          <AdaButton title="Tabelle kopieren" :unicon="true" icon="copy"
                     type="purple"
                     style="margin-bottom: 1rem; margin-left: 2rem;"
                     @click="copyTableToClipboard"></AdaButton>
        </div>
        <table class="mailTable" id="mailTable">
          <tr>
            <th>Dealname</th>
            <th>Deal ID</th>
            <th>Advertiser</th>
            <th>Deal Type</th>
            <th>Placement</th>
            <th>Format</th>
            <th>CPM</th>
            <th>Targeting</th>
            <th>Start</th>
            <th>End</th>
            <th>Seat</th>
            <th>Seat ID</th>
            <th>SSP</th>
          </tr>
          <tbody>
          <tr v-for="deal in mailData" :key="'mailDeal_'+deal.id">
            <td>{{ deal.deal_name }}</td>
            <td>{{ deal.deal_id }}</td>
            <td>{{ deal.advertiser }}</td>
            <td>{{ deal.deal_type }}</td>
            <td>{{ deal.placement }}</td>
            <td>{{ deal.format }}</td>
            <td>{{ toEURString(deal.cpm) }}
            </td>
            <td>{{ deal.targeting }}</td>
            <td>{{ moment(deal.start).format('DD.MM.YYYY') }}</td>
            <td>{{ deal.end ? moment(deal.end).format('DD.MM.YYYY') : 'always on' }}</td>
            <td>{{ deal.seat }}</td>
            <td>{{ deal.seat_id }}</td>
            <td>{{ deal.ssp }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </Dialog>

    <!--  C O L U M N   S E T T I N G S   D I A L O G  -->
    <Dialog :show="showColumnSettings" @close="showColumnSettings = false" :show-close-button="true"
            @keyup.esc="showColumnSettings = false" class="columnSettingsDialog">
      <div style="display: flex; flex-flow: column;">
        <h4>Spalten verwalten</h4>
        <div style="margin-bottom: 1.5rem; color:#939BA2">Bitte Spalten auswählen, die in der Tabelle
          dargestellt werden sollen.
        </div>
        <div class="wrapper" style="width:600px">
          <Checkbox v-for="col in allColumns" :key="col.name"
                    @change="columnSelected($event, col)"
                    :id="col.name" :title="col.display_name"
                    :value="columns.findIndex(x => x.name === col.name) !== -1"></Checkbox>
        </div>
      </div>
    </Dialog>

    <!--  D E L E T E   D E A L   D I A L O G  -->
    <Confirm :show="showDeleteDealConfirm" :closeable="true" :ok-loading="deleteLoading"
             @close="showDeleteDealConfirm = false; dealToBeDeleted = null;"
             title="Deal löschen" @onok="deleteDeal"
             @oncancel="showDeleteDealConfirm = false; dealToBeDeleted = null;"
             :options="{confirm: {
                        title: 'Löschen',
                        icon: 'icon-delete',
                        color:'pink'
                    },
                    cancel: {
                        title: 'Abbrechen',
                        icon: 'icon-close'
                    }}"
    >
      <div style="margin-bottom:10px">Folgenden Deal unwiderruflich löschen?</div>
      <div v-if="dealToBeDeleted" class="colContainer">
        <div class="colWrapper">
          <div class="col1">Dealname</div>
          <div class="col2">{{ dealToBeDeleted.deal_name }}</div>
        </div>
        <div class="colWrapper">
          <div class="col1">Deal ID</div>
          <div class="col2">{{ dealToBeDeleted.deal_id }}</div>
        </div>
        <div class="colWrapper">
          <div class="col1">Advertiser</div>
          <div class="col2">{{ dealToBeDeleted.advertiser }}</div>
        </div>
        <div class="colWrapper">
          <div class="col1">Deal Type</div>
          <div class="col2">{{ dealToBeDeleted.deal_type }}</div>
        </div>
        <div class="colWrapper">
          <div class="col1">Placement</div>
          <div class="col2">{{ dealToBeDeleted.placement }}</div>
        </div>
        <div class="colWrapper">
          <div class="col1">Format</div>
          <div class="col2">{{ dealToBeDeleted.format }}</div>
        </div>
        <div class="colWrapper">
          <div class="col1">Agentur</div>
          <div class="col2">{{ dealToBeDeleted.agency }}</div>
        </div>
      </div>
    </Confirm>
  </div>
</template>

<script>
import AdaTable from "@/components/dataTable/AdaTable";
import Dialog from "@/components/dialogs/Dialog";
import Input from "@/components/inputs/Input";
import AdaButton from "@/components/buttons/AdaButton";
import {RepositoryFactory} from "@/scripts/RepositoryFactory";
import RadioButton from "@/components/inputs/RadioButton";
import DatePicker from "@/components/datePicker/DatePicker";
import Checkbox from "@/components/inputs/Checkbox";
import Confirm from "@/components/dialogs/Confirm";
import Dropdown from "@/components/inputs/DropDown";

const DeallistRepository = RepositoryFactory.get('deallist');

export default {
  name: "Deallist",
  components: {Dropdown, Confirm, Checkbox, DatePicker, RadioButton, AdaButton, Input, Dialog, AdaTable},
  props: {
    onlyArchived: {
      type: Boolean,
      default: false,
    },
    showActionCol: {
      type: Boolean,
      default: false,
    }
  },
  data: () => ({
        columns: [{
          label: 'Dealname',
          name: 'deal_name'
        }, {
          label: 'Deal ID',
          name: 'deal_id'
        }, {
          label: 'Advertiser',
          name: 'advertiser'
        }, {
          label: 'Deal Type',
          name: 'deal_type'
        }, {
          label: 'Placement',
          name: 'placement'
        }, {
          label: 'Format',
          name: 'format'
        }, {
          label: 'CPM',
          name: 'cpm'
        }, {
          label: 'Agentur',
          name: 'agency'
        }, {
          label: 'Stopped',
          name: 'deallist_status',
          noSort: true,
        }],
        selectedOriginal: null, //original Selected data
        selected: null, //selected data to edit -> so the table doesn't change while you edit
        showDetailsDialog: false,
        loading: false,
        updateKey: 0,
        excelLoading: false,
        mailLoading: false,
        showMailDialog: false,
        showColumnSettings: false,
        showDeleteDealConfirm: false,
        mailData: null,
        cbx_all: false,
        dealToBeDeleted: null,
        deleteLoading: false,
        dropdownsLoading: true,
        transformers: [
          {
            propName: 'cpm',
            transform: function (value) {
              return value ? value.toLocaleString('de-DE', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 2
              }) : null;
            }
          },
          {
            propName: 'budget',
            transform: function (value) {
              return value ? value.toLocaleString('de-DE', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 2
              }) : null;
            }
          },
        ]
      }
  ),
  async mounted() {
    if (this.showActionCol) {
      this.columns.push({
        label: "Aktion",
        name: 'action'
      })
    }
    await this.getAllDropdowns();
  },
  watch: {
    columns() {
      this.updateKey++;
    }
  },
  computed: {
    vuexState() {
      return this.$store.state.deallist;
    }
    ,
    selectedRows() {
      return this.vuexState.selectedRows;
    }
    ,
    validSelectedRows() {
      return Object.entries(this.selectedRows).filter(x => x[1] === true).map(x => x[0]);
    }
    ,
    finalFilter() { //for Deallist
      return this.onlyArchived ? this.vuexState.finalFilterArchived : this.vuexState.finalFilter;
    }
    ,
    allColumns() {
      return this.vuexState.columns;
    }
    ,
  }
  ,
  methods: {
    async getAllDropdowns() {
      if (this.vuexState.dropdowns === null) this.dropdownsLoading = true;
      const [users, seats, formats, devices, dealtypes, placements, brandings, salesoffices, reportings, advertisers] = await Promise.all([
        DeallistRepository.getUsers(), DeallistRepository.getSeats(), DeallistRepository.getFormats(),
        DeallistRepository.getDevices(), DeallistRepository.getDealtypes(), DeallistRepository.getPlacements(),
        DeallistRepository.getBrandings(), DeallistRepository.getSalesoffices(), DeallistRepository.getReportings(),
        DeallistRepository.getAdvertisers(),
      ]);
      users.data.forEach((user) => {
        user.full_name = user.last_name + ', ' + user.first_name + ' ' + this.getEmailDomain(user.email);
      })
      this.$store.commit('deallist/updateDropdowns', [//asdasd@ad-alliance.de
        {name: 'users', data: users.data || null},
        {name: 'seats', data: seats.data || null},
        {name: 'formats', data: formats.data || null},
        {name: 'devices', data: devices.data || null},
        {name: 'dealtypes', data: dealtypes.data || null},
        {name: 'placements', data: placements.data || null},
        {name: 'brandings', data: brandings.data || null},
        {name: 'salesoffices', data: salesoffices.data || null},
        {name: 'reportings', data: reportings.data || null},
        {name: 'advertisers', data: advertisers.data || null},
      ])
      this.dropdownsLoading = false;
    },
    getEmailDomain(email) {
      let mail2ndPart = email.split('@')[1];
      let domain = mail2ndPart.split('.')[0].replaceAll('-', ' ');
      const separatedDomain = domain.split(" ");

      for (let i = 0; i < separatedDomain.length; i++) {
        separatedDomain[i] = separatedDomain[i][0].toUpperCase() + separatedDomain[i].substr(1);
      }
      return "[" + separatedDomain.join(" ") + "]"
    },
    showDetails(data) {
      if (data.column !== "checkbox" && data.column !== "action") {
        this.selectedOriginal = data.row;
        this.selected = JSON.parse(JSON.stringify(this.selectedOriginal));
        this.selected.cpm = this.toEURString(this.selected.cpm);
        this.selected.budget = this.toEURString(this.selected.budget);
        this.selected.start = this.selected.start ? this.moment(this.selected.start).format('DD.MM.YYYY') : null;
        this.selected.end = this.selected.end ? this.moment(this.selected.end).format('DD.MM.YYYY') : 'always on';
        this.showDetailsDialog = true;
      }
    }
    ,
    async save() {
      if (this.selected) {
        try {
          this.loading = true;
          let json = JSON.parse(JSON.stringify(this.selected));
          json.cpm = json.cpm ? this.parseNumber(json.cpm) : json.cpm;
          json.budget = json.budget ? this.parseNumber(json.budget) : json.budget;
          json.start = this.moment(json.start, 'DD.MM.YYYY').format('YYYY-MM-DD HH:mm:ss');
          json.end = json.end === 'always on' ? null : this.moment(json.end, 'DD.MM.YYYY').format('YYYY-MM-DD HH:mm:ss');
          await DeallistRepository.update(json.id, json);
          this.updateKey++;
          this.showDetailsDialog = false;
          this.$noty.success('Erfolgreich gespeichert');
          this.loading = false;
        } catch (e) {
          this.loading = false;
          console.error(e);
          this.$noty.error('Speichern fehlgeschlagen');
        }
      } else {
        this.$noty.error('Speichern fehlgeschlagen');
      }
    }
    ,
    updateSelectedRows(row) {
      this.$store.commit('deallist/updateSelectedRows', row);
    }
    ,
    async generateExcel() {
      this.excelLoading = true;
      try {
        const {data} = await DeallistRepository.export(
            {
              allChecked: this.cbx_all,
              filter: this.finalFilter,
              data: this.validSelectedRows,
              archived: this.onlyArchived,
            });
        const today = new Date();
        const yyyy = today.getFullYear();
        let mm = today.getMonth() + 1; // Months start at 0!
        let dd = today.getDate();
        let blob = new Blob([data], {type: 'application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'deallist_export_' + yyyy + mm + dd + '.xlsx';
        link.click();
      } catch (e) {
        console.error(e);
        this.$noty.error('Fehler beim Excel Download');
      }
      this.excelLoading = false;
    }
    ,
    async getFilteredEntries() {
      this.mailLoading = true;
      try {
        const {data} = await DeallistRepository.getFilteredEntries({
          allChecked: this.cbx_all,
          filter: this.finalFilter,
          data: this.validSelectedRows,
          archived: this.onlyArchived,
        });
        this.mailData = data.result;
        this.showMailDialog = true;
      } catch (e) {
        console.error(e);
      }
      this.mailLoading = false;
    }
    ,
    updateDate(date, model) {
      this.selected[model] = date ? this.moment(date).format('DD.MM.YYYY') : 'always on';
    }
    ,
    setCbxAll(value) {
      this.cbx_all = value;
    }
    ,
    copyTableToClipboard() {
      let el = document.getElementById('mailTable');
      var body = document.body,
          range,
          sel;
      if (document.createRange && window.getSelection) {
        range = document.createRange();
        sel = window.getSelection();
        sel.removeAllRanges();
        try {
          range.selectNodeContents(el);
          sel.addRange(range);
        } catch (e) {
          range.selectNode(el);
          sel.addRange(range);
        }
      } else if (body.createTextRange) {
        range = body.createTextRange();
        range.moveToElementText(el);
        range.select();
      }
      document.execCommand("Copy");
    }
    ,
    openColumnSettings() {
      this.showColumnSettings = true;

    }
    ,
    columnSelected(isChecked, col) {
      if (isChecked) {
        this.columns.push({
          label: col.display_name,
          name: col.name
        })
      } else {
        this.columns.splice(this.columns.findIndex(x => x.name === col.name), 1);
      }
      this.$noty.success("Tabelle aktualisiert");
    }
    ,
    openDeleteConfirm(deal) {
      this.showDeleteDealConfirm = true;
      this.dealToBeDeleted = deal;
    }
    ,
    async deleteDeal() {
      if (this.dealToBeDeleted) {
        try {
          this.deleteLoading = true;
          await DeallistRepository.delete(this.dealToBeDeleted.id);
          this.updateKey++;
          this.showDeleteDealConfirm = false;
          this.$noty.success('Deal erfolgreich gelöscht');
          this.deleteLoading = false;
        } catch (e) {
          this.deleteLoading = false;
          console.error(e);
          this.$noty.error('Deal löschen fehlgeschlagen');
        }
      } else {
        this.$noty.error('Deal löschen fehlgeschlagen: Kein Deal ausgewählt.');
      }
    }
    ,
    getDropdown(nameInStore, selectedName, dropDownItemKey = 'name') {
      let ret = this.vuexState.dropdowns.find(x => x.name === nameInStore) ?
          JSON.parse(JSON.stringify(this.vuexState.dropdowns.find(x => x.name === nameInStore).data)) : [];

      //if not in dropdown add, so it can be displayed
      if (!ret.find(x => this.selected[selectedName] === x[dropDownItemKey])) {
        let tmp = {hide: true};
        tmp[dropDownItemKey] = this.selected[selectedName];
        ret.push(tmp);
      }
      return ret
    }
    ,
    updateModel(data, name, itemName) {
      if (this.selected[name] !== data[itemName]) {
        this.selected[name] = data[itemName];
        if (name === 'seat') {
          this.selected.seat_id = data.seat_id;
          this.selected.ssp = data.ssp;
          this.selected.dsp = data.dsp;
          this.selected.agency_group = data.agency_group;
          this.selected.agency = data.agency;
          this.$noty.info('Seat ID, SSP, DSP, Agenturgruppe & Agentur an <b>' + data.name + '</b> angepasst.');
        }
      }
    },
    parseNumber(val) {
      return parseFloat(val.replaceAll('.', "").replace(',', "."))
    },
    toEURString(val) {
      return val ? val.toLocaleString('de-DE', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
      }) : null
    }
  },
}
</script>

<style lang="scss" scoped>
:deep( .detailDialog .button_container ){
  display: flex;
  flex-flow: row;
  margin-bottom: 1em;
  justify-content: flex-end;

  button {
    height: 2.2em;
  }
}

:deep( .detailDialog .content .contentWrapper ){
  margin-top: 1rem;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 79vh;
  height: 800px;
  padding-right: 1rem;
}

:deep( .detailDialog .modal-container:not(.datePicker .modal-container)) {
  //max-width: 1000px !important;
  width: 800px !important;
  max-width: 80vw !important;
  height: 950px !important;
  max-height: 93vh;
  overflow: hidden;
}

:deep( .mailDialog .modal-container:not(.datePicker .modal-container)) {
  //max-width: 1000px !important;
  width: 1200px !important;
  max-width: 80vw !important;
  height: 1000px !important;
  max-height: 93vh;
  overflow: auto;
}

.row {
  display: flex;
  flex-flow: row;
  margin-bottom: 0.4rem;

  > div, .floating.border {
    width: 100% !important;

    &:not(:last-child) {
      margin-right: 1rem;
    }
  }
}

.textarea {
  textarea {
    resize: none !important;
  }

  &.floating {
    margin-bottom: 10px;
    background-color: transparent;
    transition: background-color 0.2s ease;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    position: relative;
  }

  .floating__input {
    padding: 1rem 0.6rem 0.4rem;
    font-size: 1rem;
    border: none;
    border-bottom: 1px solid #d0d4da;
    transition: border-color 0.2s ease;
    caret-color: #00b6ed;
    width: 100%;

  }

  textarea.floating__input:disabled {
    background-color: rgba(255, 255, 255, 0.51);
    cursor: no-drop;
  }

  &.border {
    .floating__input {
      padding: 1rem 0.6rem 0.4rem;
      border: 1px solid #d0d4da !important;
    }

    .floating__label::before {
      left: 11px;
    }
  }

  .floating__input:focus-visible {
    outline: none;
  }

  .floating__input::placeholder {
    color: rgba(0, 0, 0, 0);
  }

  .floating__label {
    display: block;
    position: relative;
    max-height: 0;
    font-weight: 400;
    pointer-events: none;
  }

  .floating__label::before {
    color: #394956;
    content: attr(data-content);
    display: inline-block;
    filter: blur(0);
    backface-visibility: hidden;
    transform-origin: left top;
    transition: transform 0.2s ease;
    left: 10px;
    position: relative;
  }

  .floating__label::after {
    bottom: 1rem;
    content: "";
    height: 0.1rem;
    position: absolute;
    transition: transform 180ms cubic-bezier(0.4, 0, 0.2, 1),
    opacity 180ms cubic-bezier(0.4, 0, 0.2, 1), background-color 0.3s ease;
    opacity: 0;
    left: 0;
    top: 100%;
    margin-top: -0.1rem;
    transform: scale3d(0, 1, 1);
    width: 100%;
    background-color: #00b6ed;
  }

  .floating__input:focus + .floating__label::after {
    transform: scale3d(1, 1, 1);
    opacity: 1;
  }

  .floating__input:placeholder-shown + .floating__label::before {
    transform: translate3d(0, -4.3rem, 0) scale3d(1, 1, 1);
  }

  .floating__label::before, .floating__input:focus + .floating__label::before {
    transform: translate3d(0, -5rem, 0) scale3d(0.72, 0.72, 1);
  }

  .floating__input:focus + .floating__label::before {
    color: #00b6ed;
  }
}

:deep( table tbody tr) {
  &.missingDealID {
    color: #B0BEC5 !important;
  }

  td:not(.checkbox) {
    cursor: pointer;
  }
}

:deep(.archive table thead tr:first-child ){
  background: linear-gradient(90deg, #91a6ad, #595075 75%, #533c5a);
}

.actionButtons {
  display: flex;
  position: absolute;
  top: 4rem;
  right: 0;
  z-index: 1;

  :deep(button ){
    min-width: 0 !important;
  }
}

:deep( .tableFilters ){
  padding: 10px 280px 10px 10px;
}


.mailTable {
  font-size: 12px;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  text-align: left;
  box-sizing: border-box;
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 1rem;
  background-color: transparent;

  th {
    font-size: 12px;
    line-height: 1.5;
    border-collapse: collapse;
    box-sizing: border-box;
    text-align: left;
    vertical-align: bottom;
    color: #fff;
    background-color: #00b6ed;
    border-color: #879aac;
    white-space: nowrap;
    padding: 2px 5px;
  }

  tbody {
    tr:nth-child(even) td {
      background: #f4f4f4;
    }

    td {
      cursor: default !important;
      padding: 2px 5px;
      font-size: 12px;
      font-weight: 400;
      line-height: 1.5;
      color: #212529;
      text-align: left;
      border-collapse: collapse;
      box-sizing: border-box;
      vertical-align: top;
      border-top: 1px solid #dee2e6;
      white-space: nowrap;
      overflow: hidden;
      background: #fbfbfc;
    }
  }
}

.col_settings :deep(.unicon.icon) {
  margin-right: 0;
  padding: 9px 0 9px 6px;
}


.columnSettingsDialog .wrapper .checkbox-container {
  min-width: 200px;
  margin: .5rem 0;
}

.colContainer {
  display: flex;
  flex-flow: column;
  max-width: 500px;

  .colWrapper {
    display: flex;
    flex-flow: row;
    padding: 10px;

    &:nth-child(odd) {
      background: #f4f6f7;
    }

    .col1 {
      min-width: 8rem;
      text-transform: uppercase;
      padding-top: 3px;
      font-size: 0.8rem;
      font-weight: 600;
      color: #546E7A;
    }

    .col2 {
      word-break: break-word;
    }
  }
}


:deep( .tableFilters .filtersInner), :deep(.filtersInner .control), :deep( .filtersInner .inputcontainer) {
  display: flex;
}

:deep( .filtersInner .inputcontainer){
  max-height: 40px;
}
</style>